import {
  TeaserEntry,
  AudioTeaserEntry,
} from "../helper/interfaces";
import React, { useContext } from "react";
import { Mic, Play, Pause, Info } from "react-feather";

import { AppTheme, ContentType, TeaserViewType } from "../helper/enums";
import { getAuthorNames } from "../helper/author";
import { AppContext } from "../provider/AppContextProvider";
import { getTeaserImageUrl } from "../helper/images";
import CustomImage from "./ui/Image";
import TeaserInfos from "./TeaserInfos";
import parse from "html-react-parser";
import TeaserInArticleNN from "./TeaserInArticleNN";

export interface TeaserData {
  teaser: TeaserEntry;
  isArticleTeaser?: boolean;
  ignoreLead?: boolean;
  isImportantTeaser?: boolean;
  viewType?: TeaserViewType;
}

function TeaserBaseNN(data: TeaserData) {
  const { audioPlayer } = useContext(AppContext);

  const teaser = data.teaser;
  const image = teaser?.images ? teaser.images[0] : undefined;
  const imageUrl = image && getTeaserImageUrl(image);

  const authorNames = getAuthorNames(teaser.authors);

  if (
    data.isArticleTeaser &&
    process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nn &&
    teaser.type !== ContentType.Podcast
  ) {
    return <TeaserInArticleNN teaser={data.teaser} />;
  }

  return (
    <>
      {imageUrl && (
        <div className="teaser-image">
          <CustomImage
            src={imageUrl}
            fill
            className="object-cover"
            alt={image.title}
          />
          {data.isImportantTeaser && (
            <div className="teaser-important">
              Eilmeldung
              <Info />
            </div>
          )}

          {teaser.type === ContentType.Podcast && (
            <div className="teaser-module-icon">
              <Mic />
            </div>
          )}

          {teaser.highlight && (
            <div className="teaser-body">
              {data.viewType != TeaserViewType.Masonry && (
                <TeaserInfos teaser={teaser} />
              )}

              <div className="teaser-details">
                {teaser.type === ContentType.Podcast && (
                    <div className="teaser-podcast-play">
                      {audioPlayer?.playing &&
                      audioPlayer.audioUrl ===
                        (teaser as AudioTeaserEntry).audioUrl ? (
                        <div className="icon-button_play_feather">
                          <Pause />
                        </div>
                      ) : (
                        <div className="icon-button_play_feather">
                          <Play />
                        </div>
                      )}
                    </div>
                  )}

                {data.viewType == TeaserViewType.Masonry && (
                  <TeaserInfos teaser={teaser} />
                )}

                {teaser.title && (
                    <div className="teaser-title-box">
                      <h3 className="teaser-title">
                        {teaser.topline &&
                          teaser.type != ContentType.Podcast && (
                            <div className="teaser-title-topline">
                              <span>{teaser.topline}</span>
                            </div>
                          )}
                        <span>{teaser.title}</span>
                      </h3>
                    </div>
                  )}
              </div>

              {data.ignoreLead != true && teaser.lead && (
                <p className="teaser-lead">{teaser.lead}</p>
              )}

              {(teaser.subline || authorNames) && (
                <div className="teaser-meta">
                  <span className="teaser-author">
                    {authorNames && `Von ${authorNames}`}
                  </span>
                  <span className="teaser-date">{teaser.subline}</span>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {!imageUrl && (
        <div className="teaser-image">
          <CustomImage
            src="/images/fallback_image.png"
            fill
            className="object-cover"
            alt="fallback"
          />
        </div>
      )}

      {!teaser.highlight && (
        <div className="teaser-body">
          {data.viewType != TeaserViewType.Masonry && (
            <TeaserInfos teaser={teaser} />
          )}

          <div className="teaser-details">
            {teaser.type === ContentType.Podcast && (
                <div className="teaser-podcast-play">
                  {audioPlayer?.playing &&
                  audioPlayer.audioUrl ===
                    (teaser as AudioTeaserEntry).audioUrl ? (
                    <div className="icon-button_play_feather">
                      <Pause />
                    </div>
                  ) : (
                    <div className="icon-button_play_feather">
                      <Play />
                    </div>
                  )}
                </div>
              )}

            {data.viewType == TeaserViewType.Masonry && (
              <TeaserInfos teaser={teaser} />
            )}

            {teaser.title && (
                <div className="teaser-title-box">
                  <h3 className="teaser-title">
                    {teaser.topline &&
                      teaser.type != ContentType.Podcast && (
                        <div className="teaser-title-topline">
                          <span>{teaser.topline}</span>
                        </div>
                      )}
                    <span>{teaser.title}</span>
                  </h3>
                </div>
              )}
          </div>

          {data.ignoreLead != true && teaser.lead && (
            <p className="teaser-lead">{parse(teaser.lead)}</p>
          )}

          {(teaser.subline || authorNames) && (
            <div className="teaser-meta">
              <span className="teaser-author">
                {authorNames && `Von ${authorNames}`}
              </span>
              <span className="teaser-date">{teaser.subline}</span>
            </div>
          )}
        </div>
      )}
      {!data.ignoreLead && teaser.lead && (
        <div className="teaser-lead-nn">{parse(teaser.lead)}</div>
      )}
    </>
  );
}

export default TeaserBaseNN;
